import React from "react";
import { useGetCampaignById, useUpdateCampaign } from "@/features/campaigns/hooks/useCampaign";
import { useCampaignId } from "@/features/campaigns/hooks/useCampaignId";
import { cleanMessageTemplates } from "@/features/campaigns/utils/stepContentMode";
import CampaignMessageTemplatesModal from "./CampaignMessageTemplatesModal";

/** Campaign messages editor that loads and saves the current campaign's templates itself. */
const CampaignMessagesEditor = ({ isOpen, onClose, initialChannel }) => {
  const campaignId = useCampaignId();
  const { data } = useGetCampaignById(campaignId, isOpen && Boolean(campaignId));
  const campaign = data?.data ?? data;
  const { mutate: updateCampaign, isPending } = useUpdateCampaign(campaignId);

  return (
    <CampaignMessageTemplatesModal
      isOpen={isOpen}
      onClose={onClose}
      campaignId={campaignId}
      initialChannel={initialChannel}
      value={cleanMessageTemplates(campaign?.message_templates)}
      isSaving={isPending}
      description="Changes apply to every lead whose step uses the campaign message."
      onSave={(messageTemplates) =>
        updateCampaign({ campaignId, campaignData: { messageTemplates } }, { onSuccess: onClose })
      }
    />
  );
};

export default CampaignMessagesEditor;
